import { IVisitPeriod } from "../types/ownerDashboard.types";

const ALL_TIME_FALLBACK_YEARS = 20;

function formatVisitDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

export function getAllTimePeriod(
  referenceDate = new Date(),
  historyYears?: number
): IVisitPeriod {
  const yearsBack = Math.max(historyYears ?? 0, ALL_TIME_FALLBACK_YEARS);
  const startYear = referenceDate.getFullYear() - yearsBack;

  return {
    initial_date: `01/01/${startYear}`,
    final_date: formatVisitDate(referenceDate),
  };
}
